import { Reveal, SectionHeading } from "../Reveal";
import { useContent } from "../../context/ContentContext";

export const HowItWorks = () => {
  const { steps } = useContent();
  return (
    <section className="bg-white py-24" data-testid="how-it-works-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading center eyebrow={steps.eyebrow} title={steps.title} />
        </Reveal>

        <div className="relative mt-16 grid gap-8 md:grid-cols-4">
          <div className="absolute left-0 right-0 top-8 hidden border-t-2 border-dashed border-navy/15 md:block" />
          {steps.items.map((s, i) => (
            <Reveal key={s.n || i} delay={i * 0.1} className="relative">
              <div className="flex flex-col items-center text-center">
                <span className="relative z-10 flex h-16 w-16 items-center justify-center rounded-full bg-navy font-display text-xl font-black text-white ring-8 ring-white">
                  {s.n || String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-5 font-display text-lg font-bold text-navy">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
